/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { AxesHelper } from 'three';
import { CapNames } from '../CapNames';
/**
 * capability to draw a simple axis
 */
export class AxisHelperCap {
    getName() {
        return CapNames.AXIS;
    }
    /**
     * see base class
     */
    call(objectIn, sceneIn) {
        const { payload } = objectIn;
        if (!!payload && payload.axisLength != null) {
            const axes = new AxesHelper(payload.axisLength);
            axes.name = objectIn.name;
            axes.userData.imaginary = true;
            sceneIn.add(axes);
            return true;
        }
        return false;
    }
}
//# sourceMappingURL=AxisHelperCap.js.map